angular.module('pitch.app')
.directive('hoverSpy', function() {
    "use strict";

    return {
        restrict: 'A',
        link: function($scope, elem, attr, ctrl) {
            elem.addClass('hover-spy-el');

            function add() {
                elem.parent().addClass('hover-spy-hover');
            }

            function remove() {
                elem.parent().removeClass('hover-spy-hover');
            }

            elem.on('mouseenter', add);
            // elem.on('focus', add);
            elem.on('mouseleave', remove);
            // elem.on('blur', remove);

            $scope.$on('$destroy', function() {
                elem.off('mouseenter', add);
                elem.off('mouseleave', remove);
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/directives/hoverSpy.js